import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoaderProps {
  message?: string;
  fullScreen?: boolean;
}

export function Loader({ message = 'Logging out...', fullScreen = false }: LoaderProps) {
  const loaderContent = (
    <div className="flex flex-col items-center justify-center space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="relative flex items-center justify-center">
        <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
        <div className="bg-background/80 backdrop-blur-md p-4 rounded-2xl shadow-xl border border-white/10 relative z-10">
          <Loader2 className="w-8 h-8 text-primary animate-spin" />
        </div>
      </div>
      {message && (
        <p className="text-sm font-medium text-foreground bg-background/50 backdrop-blur-sm px-4 py-1.5 rounded-full border border-white/5 shadow-sm">
          {message}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/60 backdrop-blur-md transition-all duration-300">
        {loaderContent}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full h-full p-8">
      {loaderContent}
    </div>
  );
}
